(function () {
  const stickyControlsStyleId = "jm-sticky-controls-hotfix";
  if (!document.getElementById(stickyControlsStyleId)) {
    const style = document.createElement("style");
    style.id = stickyControlsStyleId;
    style.textContent = `
@media (max-width: 900px) {
  .jm-application.has-started .jm-form-card { padding-bottom: calc(var(--jm-card-padding) + 96px) !important; }
  .jm-application.has-started .jm-controls:not(.jm-controls--single) {
    position: fixed !important;
    left: 12px !important;
    right: 12px !important;
    bottom: 0 !important;
    z-index: 30 !important;
    margin: 0 !important;
    padding: 12px !important;
    background: rgba(8, 8, 8, .96) !important;
    border: 1px solid rgba(233, 189, 69, .28) !important;
  }
}
@media (max-width: 640px) {
  .jm-application.has-started .jm-form-card { padding-bottom: calc(var(--jm-card-padding) + 150px) !important; }
}`;
    document.head.append(style);
  }

  const root = document.querySelector("[data-coaching-application]");
  if (!root) return;

  const form = root.querySelector("[data-application-form]");
  const steps = Array.from(root.querySelectorAll("[data-step]"));
  const progressItems = Array.from(root.querySelectorAll("[data-progress-step]"));
  const mobileProgress = root.querySelector("[data-mobile-progress]");
  const mobileProgressCount = root.querySelector("[data-mobile-progress-count]");
  const mobileProgressLabel = root.querySelector("[data-mobile-progress-label]");
  const mobileProgressBar = root.querySelector("[data-mobile-progress-bar]");
  const nextButton = root.querySelector("[data-next-step]");
  const prevButton = root.querySelector("[data-prev-step]");
  const submitButton = root.querySelector("[data-submit-application]");
  const controls = root.querySelector(".jm-controls");
  const errorBox = root.querySelector("[data-form-error]");
  const summaryField = root.querySelector("[data-summary-field]");
  const successPanel = root.querySelector("[data-success-panel]");
  const rangeInputs = Array.from(root.querySelectorAll("[data-range-input]"));
  const isSingleForm = root.hasAttribute("data-single-form");
  const minTextareaLength = 12;

  if (!form || !steps.length || !submitButton || (!isSingleForm && (!nextButton || !prevButton))) {
    progressItems.forEach((item) => item.classList.add("is-complete"));
    return;
  }

  let currentStep = 0;
  let hasInitializedSteps = false;

  const fieldOrder = [
    "full_name",
    "email",
    "phone",
    "age",
    "applying_for",
    "biggest_frustration",
    "confidence_effect",
    "dealing_with_duration",
    "what_tried",
    "worked_with_coach",
    "coaching_type",
    "coach_experience",
    "followed_program",
    "programs_followed",
    "program_results",
    "program_missing",
    "training_days",
    "current_training",
    "tracking_food",
    "seriousness",
    "holding_back",
    "willing_to_follow_structure",
    "ready_to_invest",
    "start_timing",
    "if_nothing_changes",
    "if_fixed",
    "best_contact_method"
  ];

  function getFieldValue(key) {
    const fields = Array.from(form.querySelectorAll(`[data-field="${key}"]`));
    if (!fields.length) return "";

    const radio = fields.find((field) => field.type === "radio");
    if (radio) {
      const checked = fields.find((field) => field.checked);
      return checked ? checked.value : "";
    }

    return fields[0].value.trim();
  }

  function getFieldLabel(key) {
    const field = form.querySelector(`[data-field="${key}"]`);
    const labelSource = field?.closest("[data-field-label]");
    const label = labelSource?.dataset.fieldLabel?.trim();
    if (label) return label;
    return key.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
  }

  function isConditionalVisible(key) {
    return form.querySelector(`[data-conditional="${key}"]`)?.classList.contains("is-visible") || false;
  }

  function normalizePhoneDigits(value) {
    let digits = value.replace(/\D/g, "");
    if (digits.length === 11 && digits.startsWith("1")) digits = digits.slice(1);
    return digits.slice(0, 10);
  }

  function formatPhone(value) {
    const digits = normalizePhoneDigits(value);
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  function populateAgeSelects() {
    root.querySelectorAll("[data-age-select]").forEach((select) => {
      if (select.options.length > 1) return;
      for (let age = 18; age <= 80; age += 1) {
        const option = document.createElement("option");
        option.value = String(age);
        option.textContent = String(age);
        select.append(option);
      }
      const option = document.createElement("option");
      option.value = "81+";
      option.textContent = "81+";
      select.append(option);
    });
  }

  function setError(message, target) {
    errorBox.textContent = message || "";
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "center" });
      const focusable = target.matches("input, textarea, button") ? target : target.querySelector("input, textarea, button");
      if (focusable) focusable.focus({ preventScroll: true });
    }
  }

  function markInvalid(target, invalid) {
    if (!target) return;
    const container = target.closest(".jm-field, .jm-choice-group") || target;
    container.classList.toggle("is-invalid", Boolean(invalid));
  }

  function isFieldValid(field) {
    if (!field) return true;
    if (field.hasAttribute("data-required") && !field.value.trim()) return false;
    if (field.matches("textarea[data-required]") && field.value.trim().length < minTextareaLength) return false;
    if (field.type === "email" && field.value.trim() && !field.validity.valid) return false;
    if (field.matches("[data-phone-field]") && field.value.trim() && normalizePhoneDigits(field.value).length !== 10) return false;
    return true;
  }

  function clearErrorIfResolved(field) {
    if (!errorBox.textContent || !isFieldValid(field)) return;
    markInvalid(field, false);
    setError("");
  }

  function validateStep(index) {
    const step = steps[index];
    if (!step) return true;

    const requiredFields = Array.from(step.querySelectorAll("[data-required]"));
    for (const field of requiredFields) {
      markInvalid(field, false);
      if (!field.value.trim()) {
        markInvalid(field, true);
        setError("Please complete the highlighted field before continuing.", field);
        return false;
      }
      if (field.matches("textarea") && field.value.trim().length < minTextareaLength) {
        markInvalid(field, true);
        setError("Please write a little more detail before continuing.", field);
        return false;
      }
      if (field.type === "email" && !field.validity.valid) {
        markInvalid(field, true);
        setError("Please enter a valid email address.", field);
        return false;
      }
      if (field.matches("[data-phone-field]") && normalizePhoneDigits(field.value).length !== 10) {
        markInvalid(field, true);
        setError("Please enter a valid 10-digit phone number.", field);
        return false;
      }
    }

    const requiredGroups = Array.from(step.querySelectorAll("[data-required-group]"));
    for (const group of requiredGroups) {
      markInvalid(group, false);
      const checked = group.querySelector("input:checked");
      if (!checked) {
        markInvalid(group, true);
        setError("Please choose an option before continuing.", group);
        return false;
      }
    }

    if (index === 4 && isConditionalVisible("coach-history") && !getFieldValue("coaching_type")) {
      const group = step.querySelector('[data-field="coaching_type"]')?.closest(".jm-choice-group");
      markInvalid(group, true);
      setError("Please choose the type of coaching you did.", group);
      return false;
    }

    if (index === 4 && isConditionalVisible("program-history")) {
      const programFields = ["programs_followed", "program_results"];
      for (const key of programFields) {
        const field = step.querySelector(`[data-field="${key}"]`);
        markInvalid(field, false);
        if (!field.value.trim()) {
          markInvalid(field, true);
          setError("Please complete the highlighted program history field.", field);
          return false;
        }
      }
    }

    setError("");
    return true;
  }

  function updateStep(nextIndex) {
    if (isSingleForm) return;

    currentStep = Math.max(0, Math.min(nextIndex, steps.length - 1));
    const progressLabel = progressItems[currentStep]?.textContent.trim() || "";

    steps.forEach((step, index) => {
      const active = index === currentStep;
      step.classList.toggle("is-active", active);
      step.classList.remove("is-entering", "is-exiting");
      step.toggleAttribute("hidden", !active);
      if (active && hasInitializedSteps) {
        step.classList.add("is-entering");
        window.setTimeout(() => step.classList.remove("is-entering"), 280);
      }
    });

    progressItems.forEach((item, index) => {
      item.classList.toggle("is-active", index === currentStep);
      item.classList.toggle("is-complete", index < currentStep);
    });

    if (mobileProgress) {
      if (mobileProgressCount) mobileProgressCount.textContent = `Step ${currentStep + 1} of ${steps.length}`;
      if (mobileProgressLabel) mobileProgressLabel.textContent = progressLabel;
      if (mobileProgressBar) mobileProgressBar.style.width = `${((currentStep + 1) / steps.length) * 100}%`;
    }

    prevButton.hidden = currentStep === 0;
    nextButton.hidden = currentStep === steps.length - 1;
    submitButton.hidden = currentStep !== steps.length - 1;
    submitButton.disabled = currentStep !== steps.length - 1;
    root.classList.toggle("has-started", currentStep > 0);
    setError("");
    hasInitializedSteps = true;
  }

  function buildSummary(kind) {
    const lines = [];
    lines.push(kind === "lead" ? "Coaching Application Basic Info" : "Coaching Application");
    lines.push("");

    fieldOrder.forEach((key) => {
      if (kind === "lead" && !["full_name", "email", "phone", "age"].includes(key)) return;
      const value = getFieldValue(key);
      const label = getFieldLabel(key);
      if (value) lines.push(`${label}: ${value}`);
    });

    return lines.join("\n");
  }

  function buildBodyMessage() {
    const submittedAt = new Intl.DateTimeFormat(undefined, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date());
    const applicantName = getFieldValue("full_name") || "Unknown applicant";

    return `Coaching application submitted by ${applicantName} on ${submittedAt}. Review the parsed contact fields below.`;
  }

  function updateConditionals() {
    const toggleInputs = Array.from(form.querySelectorAll("[data-toggle-target]"));

    toggleInputs.forEach((input) => {
      const target = form.querySelector(`[data-conditional="${input.dataset.toggleTarget}"]`);
      if (!target || !input.checked) return;

      const shouldShow = input.value === input.dataset.toggleValue;
      target.classList.toggle("is-visible", shouldShow);
      target.toggleAttribute("hidden", !shouldShow);

      if (!shouldShow) {
        target.querySelectorAll("input, textarea").forEach((field) => {
          if (field.type === "radio" || field.type === "checkbox") {
            field.checked = false;
          } else {
            field.value = "";
          }
          markInvalid(field, false);
        });
      }
    });
  }

  function validateAllSteps() {
    for (let index = 0; index < steps.length; index += 1) {
      if (!validateStep(index)) {
        if (!isSingleForm) updateStep(index);
        return false;
      }
    }
    return true;
  }

  function showSuccessPanel() {
    if (!successPanel) return;

    steps.forEach((step) => {
      step.classList.remove("is-active");
      step.hidden = true;
    });
    progressItems.forEach((item) => {
      item.classList.remove("is-active");
      item.classList.add("is-complete");
    });
    root.classList.add("is-submitted");
    root.classList.remove("has-started");
    successPanel.hidden = false;
    if (controls) controls.hidden = true;
    successPanel.scrollIntoView({ behavior: "smooth", block: "center" });
    successPanel.focus?.({ preventScroll: true });
    errorBox.textContent = "";
  }

  if (!isSingleForm) {
    form.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" || event.target.matches("textarea")) return;

      event.preventDefault();
      if (currentStep === steps.length - 1) {
        submitButton.click();
      } else {
        nextButton.click();
      }
    });

    nextButton.addEventListener("click", () => {
      if (!validateStep(currentStep)) return;
      updateStep(currentStep + 1);
    });

    prevButton.addEventListener("click", () => {
      updateStep(currentStep - 1);
    });
  }

  form.addEventListener("change", (event) => {
    const target = event.target;
    if (target.matches("[data-field], [data-toggle-target]")) {
      markInvalid(target, false);
      clearErrorIfResolved(target);
      updateConditionals();
    }
  });

  form.addEventListener("input", (event) => {
    const target = event.target;
    if (target.matches("[data-phone-field]")) target.value = formatPhone(target.value);
    if (target.matches("[data-required]")) markInvalid(target, false);
    if (target.matches("[data-field]")) clearErrorIfResolved(target);
  });

  form.addEventListener("submit", (event) => {
    if (!validateAllSteps()) {
      event.preventDefault();
      return;
    }

    summaryField.value = buildBodyMessage();

    if (form.getAttribute("action") === "about:blank") {
      event.preventDefault();
      showSuccessPanel();
    }
  });

  rangeInputs.forEach((rangeInput) => {
    const rangeOutput = rangeInput.closest(".jm-range-field")?.querySelector("[data-range-output]");
    if (!rangeOutput) return;
    rangeOutput.textContent = rangeInput.value;
    rangeInput.addEventListener("input", () => {
      rangeOutput.textContent = rangeInput.value;
      clearErrorIfResolved(rangeInput);
    });
  });

  populateAgeSelects();
  updateConditionals();
  if (isSingleForm) {
    steps.forEach((step) => {
      step.hidden = false;
      step.classList.add("is-active");
    });
    progressItems.forEach((item) => item.classList.remove("is-active", "is-complete"));
  } else {
    updateStep(0);
  }

})();
